<template>
  <div class="adminLogin">
    <div class="form">
      <div align="center">
        <img width="84px;" src="../assets/images/logo.png" alt="">
      </div>
      <div class="title">宝枫林后台管理系统</div>
      <div class="row">
        
        <el-input ref='ipt' select-when-unmatched="true" style="width:300px"  type="text" @keyup.enter.native ="login()"  placeholder="请输入用户名" v-model="adminname">
          <i slot="prefix"  class="fas fa-user"></i>
        </el-input>
      </div>
      <div class="row">
        <el-input type="password" style="width:300px" @keyup.enter.native ="login()"  placeholder="请输入密码" v-model="password">
          <i  slot="prefix"  class="fas fa-lock"></i>
        </el-input>
        
      </div>
      <input class="submit" type="submit" value="登录"   @click ="login()">
    </div>
  </div>
</template>

<script>
export default {
  name: "adminLogin",
  data() {
    return {
            serve: this.$store.state.serve,
      adminname: "",
      password: ""
    };
  },
  methods: {
    
    login() {
      if (this.adminname == "") {
        this.$message.error("用户名未填写")
        // alert("用户名未填写");
        return;
      }
      if (this.password == "") {
        this.$message.error('密码未填写')
        // alert("密码未填写");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.axios
        .get(this.serve+"/admin/login", {
          params: {
            username: this.adminname,
            password: this.password
          }
        })
        .then(function(res) {
          loading.close();
          if (res.data.status == "success") {
            that.$cookies.set("token", res.data.token, "1d");
            that.$cookies.set("username", that.adminname, "1d");
            that.$router.push({ path: "/admin/admin_index" });
          } else {
            // alert(res.data.msg);
            that.$message({
              type:'error',
              message: res.data.msg
            })
          }
        })
        .catch(function(err) {
          alert("登录失败");
        });
    }
  },
  created() {
    // console.log(this.$cookies.get('token'))
  },
  mounted(){
    this.$refs.ipt.focus();
  }
};
</script>

<style lang="scss">
.adminLogin {
  background-color: #f5f5f5;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/adminLogin.jpg");
  background-repeat: no-repeat;
  background-position-y: 50%;
  .form {
    .submit {
      font-size: 18px;
      color: #fff;
      background-color: #0099ff;
      width: 300px;
      margin: 0 auto;
      border: 0;
      line-height: 50px;
      display: block;
    }
    .svg-inline--fa.fa-w-18 {
      font-size: 1.5em;
      position: relative;
      top: 0.4em;
      padding: 5px 10px;
    }
    .row {
      // border: 1px solid #ddd;
      width: 300px;
      margin: 0 auto;
      color: #999;
      margin-bottom: 20px;
      line-height: 40px;
      // display: flex;
      // align-items: center;

      // input {
      //   // border: 0;
      //   color: #999;
      //   line-height: 50px;
      //   margin-left: 6px;
        
      // }
    }
    .title {
      color: #0099ff;
      font-weight: bold;
      font-size: 29px;
      text-align: center;
      padding: 30px 0;
    }
    background-color: #fff;
    width: 350px;
    margin: auto auto;
    position: relative;
    height: 400px;
    border-top: 8px solid #0099ff;
    top: 50%;
    margin-top: -200px;
  }
}
</style>